"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _errors = _interopRequireDefault(require("../errors"));
/**
 * Returns error if account number does not pass validation
 * @param  {string} value - value of the field
 */
var validBankAccount = function validBankAccount(value) {
  var condition = /^\d+$/;
  return value && !condition.test(value) ? _errors["default"].accountNumber.validBankAccount : undefined;
};
var _default = validBankAccount;
exports["default"] = _default;
